import {getCookie} from '.'

const FBP_POLL_INTERVAL_MS = 1000
const FBP_MAX_ATTEMPTS = 10

/**
 * Reads _fbp and _fbc Meta pixel cookies.
 * If _fbp is not yet available (race condition with GTM loading the Facebook Pixel),
 * polls until it appears or a maximum number of attempts is reached.
 * @param onCookiesAvailable - Callback with { fbp, fbc } when _fbp becomes available
 */
export const identifyWithMetaPixelCookies = (
  onCookiesAvailable: (cookies: {
    fbp: string | undefined
    fbc: string | undefined
  }) => void
) => {
  const fbp = getCookie('_fbp')
  const fbc = getCookie('_fbc')

  onCookiesAvailable({fbp, fbc})

  if (fbp) return

  let attempts = 0
  const interval = setInterval(() => {
    attempts++
    const fbp = getCookie('_fbp')
    if (fbp || attempts >= FBP_MAX_ATTEMPTS) {
      clearInterval(interval)
      if (fbp) {
        const fbc = getCookie('_fbc')
        onCookiesAvailable({fbp, fbc})
      }
    }
  }, FBP_POLL_INTERVAL_MS)
}
